import {omit} from 'external/lodash'
import {useContext} from 'external/react'
import Session from 'context/session-context'

export default function useSession () {
  const {state} = useContext(Session.Context)
  const {navigation, params, active, activePage, query} = state.props
  return {...omit(state, 'props'), ...params, query, active, navigation, activePage}
}
